import {WlModal} from "../../webcomponents/modal/modal.component";


export class AgencyPremium {
    init (){
        let elementNodeListOf = document.querySelectorAll(".js-agency-logo");
        elementNodeListOf.forEach(logo => {
            logo.addEventListener('click', (event) =>{
                event.preventDefault();
                event.stopPropagation();
                this.openModal(logo as HTMLElement);
            });
        });
    }

    private openModal(logo: HTMLElement){
        let year = logo.getAttribute("data-year");
        let modal = document.getElementById("agency-premium") as WlModal;
        let spanText = modal.querySelector(".js-year");
        this.updatedContent(spanText, year, modal);
        modal.open();
    }

    private updatedContent(spanText: Element | null, year: string | null, modal: WlModal) {
        if (spanText && year && this.isMoreThanCurrentYear(parseInt(year))) {
            let spanShowYear = modal.querySelector(".js-hide-year");
            if (spanShowYear) {
                spanShowYear.classList.remove("js-hide-year");
                spanShowYear.classList.add("js-show-year");
            }
            spanText.innerHTML = year;
        }
    }

    private isMoreThanCurrentYear = (year: number): boolean => {
        const currentYear = new Date().getFullYear();
        return year !== 0 && year < currentYear;
    };
}